// extracted by mini-css-extract-plugin
export default {"wizardButton":"style_wizardButton__RicIq","primary":"style_primary__ZVbni","secondary":"style_secondary__FvOiC"};